export default "__VITE_ASSET__c68839c7__"